import { apiIvcRoutes, reportsRoutes } from '../routes'

export default (machines = []) => {
    const patterns = []
    return new Promise(resolve => {
        machines.forEach(async (machine, index) => {
            const res = await reportsRoutes.getReportByIdpm(machine.idpminspeccion)
            if (res.data[0].typepm) {
                res.data[0].typepm = encodeURIComponent(res.data[0].typepm)
            }
            const header = await apiIvcRoutes.getHeaderPauta(res.data[0])
            const struct = await apiIvcRoutes.getStructsPauta(res.data[0])
            const newPattern = res.data[0]
            newPattern.header = header
            newPattern.struct = struct
            newPattern.action = 'Inspección'
            patterns.push(newPattern)
            if (index === (machines.length - 1)) {
                resolve(patterns)
            }
        })
    })
}
